export default __webpack_public_path__ + "static/cer-6-58a19ee18321b458de670baf5e57988c.webp";